<script>
//Repositories
import Repositories from '@/repositories';
const CategoriesRepository = Repositories.get('categories');

//Mixins
import textMixin from '@/mixins/textMixin';
import dateMixin from '@/mixins/dateMixin';
// import statusMixin from '@/mixins/statusMixin';

//Components
import GridComponent from '@/components/widgets/grids/api-linked-grid';
import DeleteButton from '@/components/widgets/buttons/delete-button';

export default {
  props: {
    filters: Object,
    fields: Array,
  },
  components: {
    GridComponent,
    DeleteButton,
  },
  mixins: [textMixin, dateMixin],
  data() {
    return {
      categories: [],
      fullListSize: 0,
      gridContext: null,
      isLoading: false,
    };
  },
  created() {
    this.gridContext = {
      currentPage: 1,
      perPage: this.itemsPerPage,
      sortBy: 'name',
      sortDesc: false,
    };

    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;

      let promise = CategoriesRepository.getAll({
        ...this.filters,
        ...this.gridContext,
      }).then(({ data }) => {
        if (data != null && data.data != null) {
          this.categories = data.data;
          this.fullListSize = data.count;
        }
      });

      Promise.all([promise])
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    contextChanged(context) {
      this.gridContext = context;
      this.loadData();
    },
    deleteCategory(category) {
      CategoriesRepository.delete(category.idPublic)
        .then(() => {
          let foundIndex = this.categories.findIndex(
            (x) => x.idPublic == category.idPublic
          );
          this.categories.splice(foundIndex, 1);
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    edit(idPublic) {
      this.$router.push({ name: 'editCategory', params: { idPublic } });
    },
  },
  computed: {
    itemsPerPage() {
      return this.$store.getters['localstorage/getDynamicConfigs'](
        'gridConfig-categories-grid'
      ).itemsPerPage;
    },
  },
  watch: {
    filters() {
      this.categories = [];
      this.gridContext.currentPage = 1;
      this.loadData();
    },
  },
};
</script>

<template>
  <b-card no-body class="p-3 custom-inventory-shadow">
    <GridComponent
      v-if="gridContext != null"
      id="categories-grid"
      :fields="fields"
      :items="categories"
      :is-busy="isLoading"
      :nbItems="fullListSize"
      :default-sort="gridContext.sortBy"
      :current-page="gridContext.currentPage"
      @context-changed="contextChanged"
    >
      <template #cell(name)="data">
        <span
          v-html="
            highlightMatches(
              data.item.name,
              filters != null ? filters.search : ''
            )
          "
        />
      </template>
      <template #cell(referenceDate)="data">
        <span v-if="data.item.referenceDate">
          {{ $t(`general.${data.item.referenceDate}`) }}
        </span>
      </template>
      <template #cell(edit)="data">
        <i
          class="fas fa-pencil-alt text-success pl-2 pr-2"
          @click="edit(data.item.idPublic)"
          style="cursor: pointer; font-size: 1.3em"
        />
      </template>
      <template #cell(delete)="data">
        <DeleteButton @clicked="deleteCategory(data.item)" />
      </template>
    </GridComponent>
  </b-card>
</template>